// extracted by mini-css-extract-plugin
export default {"box":"fruits_box__Gfqng","cards":"fruits_cards__j-27k"};